import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { Header } from 'src/components'
import { CustomButton } from 'src/components/ui'
import { useTermsOfUse } from 'src/zustand/stores/termsOfUse.store'

import styles from './Welcome.module.scss'

const Welcome = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const toggleTerms = useTermsOfUse((state) => state.toggleTerms)

  const param = pathname.split('/')[2]

  const handleClick = () => {
    navigate(`${param !== 'step-3' ? (param === 'step-1' ? '/welcome/step-2' : '/welcome/step-3') : '/'}`)

    if (param === 'step-3') {
      handleClickOnAction()
    }
  }

  const handleClickOnAction = () => {
    localStorage.setItem('termsOfUse', 'accpeting')
    toggleTerms(true)
  }

  return (
    <>
      <Header variant='action' path='..' handleClickOnAction={handleClickOnAction} />

      <main className={styles.main}>
        <Outlet />

        <CustomButton className={styles.btn} onClick={handleClick} variant='contained' opacity={true} color='white'>
          {param === 'step-3' ? 'До застосунку' : 'Далі'}
        </CustomButton>
      </main>
    </>
  )
}

export default Welcome
